export type NavGroup = 'home' | 'qsc' | 'prm' | 'qa' | 'as' | 'claim' | 'more'

export const NAV = [
  {
    k: 'home',
    ko: '홈',
    icon: 'Home',
    psm: 'PSM301',
    group: 'home' as NavGroup,
  },
  {
    k: 'insp',
    ko: '매장 점검',
    icon: 'Check',
    psm: 'PSM310/315',
    group: 'qsc' as NavGroup,
  },
  {
    k: 'hist',
    ko: '점검 결과·추이',
    icon: 'Clock',
    psm: 'PSM325',
    group: 'qsc' as NavGroup,
  },
  {
    k: 'act',
    ko: '개선조치',
    icon: 'ArrowRight',
    psm: 'PSM330',
    group: 'qsc' as NavGroup,
  },
  {
    k: 'sales',
    ko: '매출 현황',
    icon: 'Bar',
    psm: 'PSM360',
    group: 'prm' as NavGroup,
  },
  {
    k: 'svstore',
    ko: '담당 매장',
    icon: 'Building',
    psm: 'PSM305',
    group: 'prm' as NavGroup,
  },
  {
    k: 'prm',
    ko: '운영 활동',
    icon: 'Handshake',
    psm: 'PRM',
    group: 'prm' as NavGroup,
  },
  {
    k: 'construction',
    ko: '공사 계약',
    icon: 'HardHat',
    psm: 'PSM-CONST',
    group: 'prm' as NavGroup,
  },
  {
    k: 'as',
    ko: 'AS 접수 확인',
    icon: 'Clipboard',
    psm: '',
    group: 'as' as NavGroup,
  },
  {
    k: 'asNew',
    ko: 'AS 접수',
    icon: 'Wrench',
    psm: '',
    group: 'as' as NavGroup,
  },
  {
    k: 'claim',
    ko: '클레임 현황',
    icon: 'Claim',
    psm: '',
    group: 'claim' as NavGroup,
  },
  {
    k: 'visitplan',
    ko: '방문 일정',
    icon: 'Pin',
    psm: 'PSM340',
    group: 'prm' as NavGroup,
  },
  {
    k: 'tpl',
    ko: '점검 템플릿',
    icon: 'Doc',
    psm: 'PSM210',
    group: 'qsc' as NavGroup,
  },
  {
    k: 'qaInsp',
    ko: '업체 점검',
    icon: 'Check',
    psm: '',
    group: 'qa' as NavGroup,
  },
  {
    k: 'qaTpl',
    ko: '점검 템플릿',
    icon: 'Doc',
    psm: '',
    group: 'qa' as NavGroup,
  },
  {
    k: 'qaAct',
    ko: '개선·검증',
    icon: 'ArrowRight',
    psm: '',
    group: 'qa' as NavGroup,
  },
  {
    k: 'qaSuppliers',
    ko: '납품업체',
    icon: 'Building',
    psm: '',
    group: 'qa' as NavGroup,
  },
  {
    k: 'voc',
    ko: 'VOC',
    icon: 'Voc',
    psm: '',
    group: 'more' as NavGroup,
  },
  {
    k: 'vote',
    ko: '투표',
    icon: 'Vote',
    psm: '',
    group: 'more' as NavGroup,
  },
  {
    k: 'notice',
    ko: '공지사항',
    icon: 'Notice',
    psm: '',
    group: 'more' as NavGroup,
  },
  {
    k: 'qna',
    ko: '1:1 문의',
    icon: 'Chat',
    psm: 'M-PSM091',
    group: 'more' as NavGroup,
  },
  {
    k: 'set',
    ko: '설정',
    icon: 'Sliders',
    psm: 'SET',
    group: 'more' as NavGroup,
  },
] as const

export type NavKey = (typeof NAV)[number]['k']
export const TAB_BAR_KEYS: NavKey[] = ['home', 'insp', 'sales', 'hist', 'set']

export const ROUTE_FOR: Record<NavKey, string> = {
  qaInsp: '/qa/insp',
  qaTpl: '/qa/tpl',
  qaAct: '/qa/act',
  qaSuppliers: '/qa/suppliers',
  home: '/home',
  insp: '/insp',
  hist: '/hist',
  act: '/act',
  sales: '/sales',
  svstore: '/svstore',
  prm: '/prm',
  construction: '/construction',
  asNew: '/as/new',
  as: '/as',
  claim: '/claim',
  visitplan: '/visitplan',
  tpl: '/tpl',
  voc: '/voc',
  vote: '/vote',
  notice: '/notice',
  qna: '/qna',
  set: '/settings',
}

export function navKeyFromPath(pathname: string): NavKey {
  if (pathname.startsWith('/settings')) return 'set'
  if (pathname.startsWith('/inq')) return 'qna'
  const entry = Object.entries(ROUTE_FOR).find(([, path]) =>
    path === '/home' ? pathname === '/home' || pathname === '/' : pathname.startsWith(path),
  )
  return (entry?.[0] as NavKey | undefined) ?? 'home'
}

export function titleForPath(pathname: string) {
  const active = navKeyFromPath(pathname)
  return NAV.find((item) => item.k === active)?.ko
}
